import { FormFieldErrors } from "global/interfaces/http.interface";
import { StepValidationPayload } from "../o-heating-form.types";
import { HeatingFormEndpoints } from "../react/model/global";

export const endpointStub = 'path:/o-heating-form/';
export const endpoints: Record<HeatingFormEndpoints, string> = {
	submitForm: 'submitForm',
	validateMainEnquiry: 'validateMainEnquiry',
	validateProductCategory: 'validateProductCategory',
	validateCustomerAddress: 'validateCustomerAddress',
	validateAdditionalInformation: 'validateAdditionalInformation',
	validateFileAttachments: 'validateFileAttachments',
	validateFormSummary: 'validateFormSummary',
}

export type PostValueType = string | number | boolean;

// export function getFormPostFields<T, U>(formBody: FormData): Map<T, U> {
// 	const fieldsMap = new Map<T, U>();

// 	if (formBody instanceof FormData) {
// 		[...formBody.entries()].map((field: any[]) => {
// 			fieldsMap.set(field[0], field[1]);
// 		});
// 	}
// 	return fieldsMap;
// }
export function getFormPostFields<T, U>(formBody: StepValidationPayload): Map<T, U> {
	const fieldsMap = new Map<T, U>();

	Object.entries(formBody.payload).map((field: any[]) => {
		fieldsMap.set(field[0], field[1]);
	});
	return fieldsMap;
}

// export function validateFormFieldsRequired<T = string, U = PostValueType>(postFieldsMap: Map<any, any>, checkFields: string[]): FormFieldErrors {
export function validateFormFieldsRequired(postFieldsMap: Map<any, any>, checkFields: string[]): FormFieldErrors {
	const errors: FormFieldErrors = {};

	const checkFieldMinlength = 1; // check for strings being required

	postFieldsMap.size > 0 && checkFields.forEach((field) => {
		const fieldData = postFieldsMap.get(field);
		switch (true) {
			case typeof fieldData === 'string': {

				if (fieldData.length < checkFieldMinlength) {
					errors[field] = `Error: ${field} is a required field`;
				}
				break;
			}

			default: break;
		}
	});
	return errors;
}
